import ApplicationElementManager from './view/ApplicationElementManager';
import { PostMessageCommand } from './messages/PostMessageCommand';

class Application {
  appName = '';
  dirty = false;
  readonly htmlElement: HTMLElement;
  private initialized = false;
  readonly title: string = '';
  private elementManager: ApplicationElementManager;

  constructor(readonly appId: string, readonly url: string, createHTMLElement: boolean) {
    this.elementManager = new ApplicationElementManager(this);
    this.htmlElement = this.elementManager.getHTMLElement(createHTMLElement);
  }

  hide() {
    this.elementManager.hideHTMLElement();
  }

  show() {
    this.elementManager.showHTMLElement();
  }

  init(useTransitionSplash?: boolean) {
    this.elementManager.initHTMLElement(this.url, useTransitionSplash);
    this.initialized = true;
  }

  isInitialized() {
    return this.initialized;
  }

  isLoaded(): boolean {
    return this.elementManager.isLoaded();
  }

  getHTMLElement() {
    return this.htmlElement;
  }

  getWindow(): Window {
    return this.elementManager.getWindow();
  }

  queueMessage(
    message: PostMessageCommand,
    executePostMessage: (message: PostMessageCommand, window: Window) => void
  ) {
    this.elementManager.queueMessage(message, executePostMessage);
  }
}

export default Application;
